import { alpha, font, media } from '../../../styles';

const getHeight = (props) => {
  switch (props.size) {
    case 'large':
      return 48;
    case 'small':
      return 24;
    case 'default':
    default:
      return 32;
  }
};

const getMinWidth = props => getHeight(props) * 3;

const getFontSize = (props) => {
  switch (props.size) {
    case 'large':
      return font.getFontSize(1.5);
    case 'small':
      return font.getFontSize(0.75);
    case 'default':
    default:
      return font.getFontSize(0.875);
  }
};

const getLineHeight = (props) => {
  switch (props.size) {
    case 'large':
      return '42px';
    case 'small':
      return '20px';
    case 'default':
    default:
      return '28px';
  }
};

const getPadding = (props) => {
  switch (props.size) {
    case 'large':
      return 24;
    case 'small':
    case 'default':
    default:
      return 12;
  }
};

const getPaddingLeft = props => props.leftIcon ? getPadding(props) + 24 : getPadding(props);
const getPaddingRight = props => props.rightIcon ? getPadding(props) + 24 : getPadding(props);

const getBorderWidth = (props) => {
  switch (props.size) {
    case 'large':
      return 3;
    case 'small':
    case 'default':
    default:
      return 2;
  }
};

const hoverRules = props => props.disabled ? ({
  backgroundColor: 'transparent',
  color: props.theme[props.color].base,
  textDecoration: 'none',
}) : ({
  backgroundColor: props.theme[props.color].base,
  color: '#ffffff',
  textDecoration: 'none',
});

const getActiveWhiteBackgroundColor = ({ theme, color}) => alpha(theme[color].dark, 0.54);

const activeRules = props => props.disabled ? ({
  backgroundColor: 'transparent',
  color: props.theme[props.color].base,
}) : ({
  boxShadow: 'none',
  backgroundColor: props.color === 'white' ?
    getActiveWhiteBackgroundColor(props) : props.theme[props.color].dark,
  borderColor: props.theme[props.color].dark,
  color: '#ffffff',
});

const getSmRules = (props) => {
  const style = props.glamStyle || {};
  const rules = style[media('sm')] || {};

  return {
    '&:hover': {
      ...hoverRules(props),
    },

    '&:active': {
      ...activeRules(props),
    },

    ...rules,
  };
};

export const Button = props => ({
  position: 'relative',
  display: 'inline-block',
  height: getHeight(props),
  width: 'auto',
  minWidth: getMinWidth(props),

  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: getPaddingLeft(props),
  paddingRight: getPaddingRight(props),

  marginRight: props.marginRight || 0,

  backgroundColor: props.isRaised ? props.theme[props.color].base : 'transparent',
  borderWidth: getBorderWidth(props),
  borderStyle: 'solid',
  borderColor: props.theme[props.color].base,
  borderRadius: getHeight(props),
  boxShadow: props.focused ? `0 0 0 2px ${props.theme[props.color].lighter}` : undefined,

  color: props.isRaised ? '#fff' : props.theme[props.color].base,
  fontSize: getFontSize(props),
  fontWeight: '400',
  lineHeight: getLineHeight(props),
  textAlign: 'center',
  textDecoration: 'none',
  textTransform: 'uppercase',

  appearance: 'none',
  cursor: props.disabled ? 'not-allowed' : 'pointer',
  opacity: props.disabled ? 0.5 : 1,
  userSelect: 'none',
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',

  ...props.glamStyle,

  [media('sm')]: getSmRules(props),


  '&:active': {
    ...activeRules(props),
  },

  '&:focus': {
    outline: 'none',
  },

  ...(props.isActive ? activeRules(props) : {}),
});


export const IconContainer = props => ({
  position: 'absolute',
  top: '50%',
  left: props.leftIcon ? (8 + props.iconOffsetLeft) : undefined,
  right: props.rightIcon ? (8 + props.iconOffsetRight) : undefined,
  width: 24,
  transform: 'translateY(-50%)',
});



// WEBPACK FOOTER //
// ./src/components/ui/Button/styles.js